import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable, signal } from '@angular/core';
import { globalStore } from '../../../../modules/shared/shared.global-service';
import { selectWorkRecordDate } from '../../../../modules/content/store/service/service.selectors';
import { offerPresenceOptions } from '../social-service-select-offer/social-service-select-offer.utils';
import {
    ServiceSettingsSocialWorkType,
} from '../../../../modules/content/pages/services/settings/service-settings-social-work/service-settings-social-work.types';
import { SERVICE_SETTINGS_SOCIAL_WORK_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import { FolderGridItemObject } from '@it2go/types';
import { getFolderByPersonFrag } from './work-mass-work.query';

@Injectable()
export class WorkMassWorkStore extends ComponentStoreV2Factory {

    public workDate = globalStore!.selectSignal(selectWorkRecordDate);

    public serviceId = signal(0);
    public folders = signal<FolderGridItemObject[]>([]);

    public personIdFromQuery = 0;
    public currentFolderId = 0;

    public settings = computed(() =>
        this.globalGlobalStore.organizationStore.getServiceSetting<ServiceSettingsSocialWorkType>(
            this.serviceId(), SERVICE_SETTINGS_SOCIAL_WORK_KEY,
        ),
    );

    public presenceOptions = computed(() => offerPresenceOptions(this.settings()));

    private fetchedFolders = new Set<string>();

    public async fetchFolder(personId: number, serviceId: number): Promise<void> {
        if (!personId || !serviceId) return;
        const key = `${personId}_${serviceId}`;
        if (this.fetchedFolders.has(key)) return;
        this.fetchedFolders.add(key);

        const result = await this.api.getFolderByPerson({ personId, serviceId }, getFolderByPersonFrag);
        if (!result) return;
        if (Number(result.personId) === Number(this.personIdFromQuery)) {
            this.currentFolderId = result.id;
        }
        this.folders.update((it) => [...it, result]);
    }

}
